import {
  ADMIN_CID_PAYOUT_STATUS_LOADED,
  ADMIN_CID_PAYOUT_STATUS_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  cidPayoutStatus: null,
};

function cidPayoutStatus(state = initialState, action) {
  switch (action.type) {
    case ADMIN_CID_PAYOUT_STATUS_LOADED:
      return { ...state, cidPayoutStatus: action.payload.cidPayoutStatus };
    case ADMIN_CID_PAYOUT_STATUS_CLEAR:
      return { ...state, cidPayoutStatus: null };
    default:
      return state;
  }
}

export default cidPayoutStatus;
